/* Cart Drawer Discount Code Handler
 *
 * Uses /discount/{code} endpoint (sets cart-level discount cookie), then
 * refreshes the cart drawer section via Shopify Section Rendering API to
 * pick up new applied discount + recompute progress bar.
 *
 * Remove: clears all cart-level discounts via /discount/clear endpoint.
 */

(function () {
  if (window.__kpcCartDrawerDiscountBound) return;
  window.__kpcCartDrawerDiscountBound = true;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function showError(formEl, msg) {
    const err = formEl.parentElement.querySelector('[data-kpc-discount-error]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }

  function clearError(formEl) {
    const err = formEl.parentElement.querySelector('[data-kpc-discount-error]');
    if (err) {
      err.textContent = '';
      err.hidden = true;
    }
  }

  async function refreshDrawer() {
    const url = `/?sections=${SECTIONS.join(',')}`;
    const resp = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!resp.ok) throw new Error(`section fetch failed: ${resp.status}`);
    const data = await resp.json();

    const drawerHTML = data['cart-drawer'];
    const bubbleHTML = data['cart-icon-bubble'];

    if (drawerHTML) {
      const parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
      const newInner = parsed.querySelector('.drawer__inner');
      const target = document.querySelector('#CartDrawer .drawer__inner');
      if (newInner && target) {
        target.innerHTML = newInner.innerHTML;
      }
    }

    if (bubbleHTML) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        const parsed = new DOMParser().parseFromString(bubbleHTML, 'text/html');
        const newBubble = parsed.querySelector('.shopify-section');
        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
      }
    }

    document.dispatchEvent(new CustomEvent('kpc:cart-drawer-refreshed'));
  }

  async function applyDiscount(code) {
    if (!code) return;
    const resp = await fetch(`/discount/${encodeURIComponent(code)}`, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
    });
    if (!resp.ok) {
      throw new Error(`apply failed (${resp.status})`);
    }
  }

  async function clearDiscount() {
    await fetch('/discount/clear', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
    }).catch(() => {});
  }

  async function handleApply(form) {
    const input = form.querySelector('[data-kpc-discount-input]');
    const apply = form.querySelector('[data-kpc-discount-apply]');
    const code = (input.value || '').trim().toUpperCase();
    if (!code) return;

    clearError(form);
    apply.disabled = true;
    apply.textContent = '…';

    try {
      await applyDiscount(code);
      await refreshDrawer();

      const stillThere = document.querySelector(`[data-discount-code="${CSS.escape(code)}"]`);
      if (!stillThere) {
        showError(form, `Code "${code}" was not applied (invalid or not eligible).`);
      }
    } catch (e) {
      showError(form, 'Could not apply code. Try again.');
      // eslint-disable-next-line no-console
      console.error('[kpc-discount] apply error', e);
    } finally {
      apply.disabled = false;
      apply.textContent = 'Apply';
    }
  }

  async function handleRemove(btn) {
    btn.disabled = true;
    try {
      await clearDiscount();
      await refreshDrawer();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[kpc-discount] remove error', e);
      btn.disabled = false;
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-kpc-discount-form]');
    if (!form) return;
    e.preventDefault();
    handleApply(form);
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-kpc-discount-remove]');
    if (!btn) return;
    e.preventDefault();
    handleRemove(btn);
  });
})();
